// extracted by mini-css-extract-plugin
export default {"linksSection":"LinksSection-module--linksSection--f7ca7"};